


























import Vue from 'vue'
import ProductCarousel from '@/top/components/ProductCarousel.vue'
import { TopProductItem } from '@/top/types'
import FavoriteBtnPopup from '@/common/components/FavoriteBtnPopup.vue'

export default Vue.extend({
  name: 'TopPageProduct',
  components: {
    ProductCarousel,
    FavoriteBtnPopup
  },
  props: {
    sectionTitle: {
      type: String,
      required: true
    },
    products: {
      type: Array as () => TopProductItem[],
      required: true
    },
    carouselName: {
      type: String,
      required: true
    },
    isPersonalizeSection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
   data() {
    return {
      currentPage: 0,
      totalPage: 0
    }
  },
  computed: {
    showCarouselBtn(): boolean {
      return this.products.length > 4
    }
  },
  methods: {
    updatePagerHandler(value: { currentPage: number, totalPage: number}) {
      this.currentPage = value.currentPage
      this.totalPage = value.totalPage
    }
  }
})
